export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_03.2e66eadc.jpg";